define([
	"dojo/_base/declare",
	"csi/action/ActionView",
	"csi/def",
	"csi/prefs/_base",
	"./ChartController"
], function(declare, ActionView, def, csiPrefs, ChartController) {

	return declare(ChartController, {
		/**
		 * @override
		 * Get node for custom view
		 */
		_preAction: function() {
			return this.getCache().getNodeDeferred(this.widget.get("customViewId"));
		},

		/**
		 * Return reference to chart wizard defined on _CS_PreferenceView.
		 * @param {ViewRef} vr - ignored
		 * @return {ActionView}
		 */
		getActionView: function(vr) {
			var defType = def.typeDefinition(csiPrefs.TYPE_VIEW);
			var defView = defType.getViewDef("ChartForm");
			return new ActionView(this, defView, this.getCache().getNode(this.widget.get("customViewId")));
		},

		/**
		 * Initialize form data with values from existing chart.
		 */
		getFormData: function() {
			if (!this.m_formData) {
				this.inherited(arguments);
				this._setChartInitialValues(this.actionValue);
			}

			return this.m_formData;
		},

		/**
		 * Give form access to chart plugin.
		 * @param {Object} params
		 */
		onCreatePopupParams: function(params) {
			params.chartPlugin = this.actionWidget;
			params.bEditing = true;
		}
	});
});
